import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { SEGUNDO_ESCALON_COVER_SRC, SEGUNDO_ESCALON_LOGO_SRC } from '../brandAssets';

const Who = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Container
          sx={{
            backgroundImage:
              themeMode === 'dark'
                ? 'url(/images/logos/logo_white.PNG)'
                : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '20vh',
          }}
        />
        <Box
          component={Typography}
          fontWeight={700}
          variant={'h3'}
          gutterBottom
          align={'center'}
          color={theme.palette.primary.main}
        >
          2do Escalón: cultura pop, juventud y el mundo real sin filtro
        </Box>
        <Typography
          variant={'h6'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
        >
          El podcast donde cuatro comunicadores en potencia descifran la vida universitaria, las tendencias y lo que viene después del carnet estudiantil.
        </Typography>
        <Typography
          variant={'h5'}
          component={'p'}
          color={theme.palette.primary.main}
          align={'center'}
          sx={{ mt: 3, mb: 2, fontStyle: 'italic' }}
        >
          ¿Qué es 2do Escalón?
        </Typography>
        <Typography align="center" sx={{ mb: 1 }}>
          <Link
            href="https://tnonetwork.com/show/2doescalon"
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            underline="hover"
          >
            tnonetwork.com/show/2doescalon
          </Link>
        </Typography>
        <Typography
          variant={'body1'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
          sx={{ mt: 1 }}
        >
          Formato juvenil del bloque <strong>Arte, Espectáculos y Entretenimiento</strong> en TNO Network: conversación
          auténtica, invitados y temas que importan a quienes están construyendo su futuro.{' '}
          <strong>Martes 1:00 PM</strong> y <strong>Viernes 2:00 PM</strong> (Venezuela) en vivo, On-Demand y redes del
          ecosistema TNO.
        </Typography>
      </Box>

      <Box marginTop={6} marginBottom={4}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={4}>
            <Box display="flex" justifyContent="center">
              <Box
                component="img"
                src={SEGUNDO_ESCALON_COVER_SRC}
                alt="2do Escalón - TNO Network"
                sx={{
                  width: { xs: 220, sm: 280, md: 320 },
                  height: 'auto',
                  borderRadius: 2,
                  objectFit: 'cover',
                  boxShadow: 3,
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography
              variant={'h5'}
              fontWeight={700}
              gutterBottom
              color={theme.palette.primary.main}
            >
              NUESTRO EQUIPO: 2DO ESCALÓN
            </Typography>
            <Typography
              variant={'body2'}
              color={'textSecondary'}
              sx={{ fontStyle: 'italic', mb: 2 }}
            >
              Cuatro voces jóvenes · periodismo en formación · humor y curiosidad sin poses de expertos.
            </Typography>
            <Typography variant={'body1'} color={'textSecondary'} sx={{ mb: 2 }}>
              <strong>2do Escalón</strong> es el espacio donde la universidad, la cultura pop, la tecnología, las
              relaciones y el «¿y ahora qué?» de la vida adulta temprana se conversan con ritmo de podcast y credibilidad
              de antena. Sin pizarra aburrida: entregas de último minuto, tendencias digitales, entrevistas y debates que
              la audiencia comparte en redes.
            </Typography>
            <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
              <Box
                component="img"
                src={SEGUNDO_ESCALON_LOGO_SRC}
                alt="Logo 2do Escalón"
                sx={{ height: 56, width: 'auto', objectFit: 'contain' }}
              />
              <Typography variant="body2" color="textSecondary">
                Ideal para marcas de educación, fintech juvenil, tecnología, moda urbana, bebidas, entretenimiento y
                patrocinio que busca Gen Z y millennials digitales.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

Who.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default Who;
